import axios from 'axios'

export default {
  ListCombo () {
    return new Promise((resolve, reject) => {
      // Recupera del cache la list de items
      const storage = sessionStorage.getItem('formaspago_itemscombo')

      // Si ya estan los datos en el storage, se retorna de ahi, solo para las paramtétricas
      if (storage)
        resolve(JSON.parse(storage))
      else {
        // realizo el llamado ajax
        const p = axios.get('/api/formaspago/ListCombo')

        p.then(({ data }) => {
          sessionStorage.setItem('formaspago_itemscombo', JSON.stringify(data.recordset))
          resolve(data.recordset)
        }).catch((err) => {
          reject(err)
        })
      }
    })
  },
  List (params) {
    return axios.get('/api/formaspago/List', { params })
  },
  Agregar (params) {
    return axios.post('/api/formaspago', params)
  },
  Modificar (params) {
    return axios.put('/api/formaspago', params)
  },
  Borrar (params) {
    return axios.delete('/api/formaspago', { params })
  }
}
